import { GlobalDatePipe } from '../../shared/pipes/global-date.pipe';

export function globalDate ( globalDatePipe : GlobalDatePipe ) {
  return ( value : string, format : string ) : string => globalDatePipe.transform(value, format);
};
